(() => {
  const links = [...document.querySelectorAll('link[data-alva-css-href]')];
  const pending = new Map();
  const load = link => {
    if (link.hasAttribute('href')) return;
    link.addEventListener('load', () => { link.dataset.alvaCssLoaded = 'true'; }, {once: true});
    link.setAttribute('href', link.dataset.alvaCssHref);
  };
  const loadAll = () => links.forEach(load);
  if (!('IntersectionObserver' in window)) { loadAll(); return; }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      (pending.get(entry.target) || []).forEach(load);
      observer.unobserve(entry.target);
    });
  }, {rootMargin: '1600px 0px'});
  links.forEach(link => {
    const targets = [...document.querySelectorAll(link.dataset.alvaCssTarget)];
    targets.forEach(target => {
      const group = pending.get(target) || [];
      group.push(link); pending.set(target, group); observer.observe(target);
    });
  });
  if (location.hash) loadAll();
  window.addEventListener('hashchange', loadAll);
  window.addEventListener('beforeprint', loadAll);
  document.addEventListener('click', event => {
    const anchor = event.target.closest && event.target.closest('a[href*="#"]');
    if (anchor) loadAll();
  }, {capture: true, passive: true});
})();
